import React from "react";
import "./AppCardProducto.css";

function formatPrecio(precio) {
  if (!precio && precio !== 0) return null;
  return `$${Number(precio).toLocaleString("es-CO")}`;
}

export default function AppCardProducto({
  nombre,
  precio,
  precio_regular,
  imagen,
  descripcion,
  enlace,
  en_oferta,
  en_stock,
}) {
  const handleComprar = () => {
    if (enlace && enlace !== "#") {
      window.location.href = enlace;
    }
  };

  const agotado = en_stock === false;
  const sinEnlace = !enlace || enlace === "#";

  return (
    <div className="producto-card">
      {en_oferta && <span className="producto-badge-oferta">¡Oferta!</span>}
      {agotado && <span className="producto-badge-agotado">Agotado</span>}

      <div className="producto-img-wrap">
        {imagen ? (
          <img src={imagen} alt={nombre} className="producto-img" loading="lazy" />
        ) : (
          <div className="producto-img-placeholder" aria-hidden="true" />
        )}
      </div>

      <div className="producto-body">
        <h3 className="producto-nombre">{nombre}</h3>
        {descripcion && <p className="producto-desc">{descripcion}</p>}

        <div className="producto-precio-wrap">
          {en_oferta && precio_regular && (
            <span className="producto-precio-tachado">{formatPrecio(precio_regular)}</span>
          )}
          {precio && (
            <span className={`producto-precio${en_oferta ? " producto-precio--oferta" : ""}`}>
              {formatPrecio(precio)}
            </span>
          )}
        </div>

        <button
          className="producto-btn"
          onClick={handleComprar}
          disabled={agotado || sinEnlace}
        >
          {agotado ? "Agotado" : sinEnlace ? "Próximamente" : "Comprar"}
        </button>
      </div>
    </div>
  );
}
